<template>
    <el-dialog :title="title+'元数据模板'" width="40%" append-to-body :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" :model="form" ref="form" label-width="140px" :rules="dataRule" v-loading="loading"
                 :disabled="method==='view'"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent>
            <el-form-item label="模板名称：" prop="basicDataName">
                <el-input v-model.trim="form.basicDataName" placeholder="请输入模板名称（限10字）" clearable
                          maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="排序：" prop="basicSort">
                <el-input-number v-model="form.basicSort" :min="1"></el-input-number>
            </el-form-item>
            <el-form-item label="可修改权限：" prop="basicDataAuthority">
                <el-radio-group v-model="form.basicDataAuthority" @input="changeEdit">
                    <el-radio :key="item.value" :label="item.value" v-for="item in $dictUtils.getDictList('basicDataAuthority')">{{item.label}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item :label="permissionName + '选择：'" prop="metadataBasicDataAuthorityId" v-show="form.basicDataAuthority != 0">
                <el-select v-model="form.metadataBasicDataAuthorityId" :placeholder="'请选择'+permissionName" multiple filterable class="w100i" clearable @change="selAuthority">
                    <el-option
                            :key="item.authorityId"
                            :label="item.disabled ? item.authorityValue+'(已禁用)' : item.authorityValue"
                            :value="item.authorityId" :disabled="item.disabled"
                            v-for="item in userOpt" v-show="!item.disabled">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="模板类型：" prop="basicDataType">
                <el-select class="w100i" v-model="form.basicDataType" placeholder="请选择模板类型" clearable>
                    <el-option
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            v-for="item in $dictUtils.getDictList('basicDataType')">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="简介：" prop="remark">
                <el-input v-model.trim="form.remark" type="textarea" :rows="2" maxlength="500"
                          placeholder="请输入简介（限500字）" clearable></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">{{ method == 'view' ? '关闭' : '取消' }}</el-button>
            <el-button size="small" type="primary" v-if="method != 'view'" v-show="!loading" :disabled="loading" @click="doSubmit()" v-noMoreClick>保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            var validateBasicSort = (rule, value, callback) => {
                if (value && value > this.sortMax) {
                    callback(new Error('排序号最大值为'+ this.sortMax));
                }
                callback();
            };
            return {
                visible: false,
                loading: false,
                title: '',
                method: '',
                sortMax: 0,
                basicParentOpt: [],
                basicAssemblyOpt: [],
                basicAssemblyAllOpt: [],
                form: {
                    id: "",
                    basicDataName: "",
                    basicSort: "",
                    basicDataAuthority: "",
                    metadataBasicDataAuthorityValues: [],
                    metadataBasicDataAuthorityId: [],
                    basicDataType: "",
                    remark: "",
                },
                permissionName: '',
                userOpt: [],
                dataRule: {
                    basicDataName: [
                        {required: true, message: '模板名称不能为空', trigger: 'blur'}
                    ],
                    basicSort: [
                        {required: true, message: '排序不能为空', trigger: 'change'},
                        {validator: validateBasicSort, trigger: 'change'}
                    ],
                    basicDataAuthority: [
                        {required: true, message: '可修改权限不能为空', trigger: 'change'}
                    ],
                    metadataBasicDataAuthorityId: [
                        {required: true, message: '', trigger: 'change'}
                    ],
                    basicDataType: [
                        {required: true, message: '模板类型不能为空', trigger: 'change'}
                    ],
                }
            }
        },
        methods: {
            // 初始化数据
            init(row, method) {
                this.getSortMax()
                this.method = method
                if (method === 'add') {
                    this.title = `新增`
                } else if (method === 'edit') {
                    this.title = '修改'
                } else if (method === 'view') {
                    this.title = '查看'
                }
                if (row) {
                    this.form.id = row.id
                } else {
                    this.form.id = ''
                }
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.form.resetFields();
                    if (this.method != 'add') {
                        this.getInfo()
                    }
                })
            },
            // 获取最大排序数
            getSortMax() {
                this.$axios(this.api.user.configKey + '/sort_max_number').then(data => {
                    if(data.status) {
                        this.sortMax = parseInt(data.data)
                    }
                })
            },
            // 查询详情信息
            getInfo() {
                this.loading = true
                this.$axios(this.api.metadata.metadatabasicdataGetById + '/' + this.form.id).then(res => {
                    if (res.status) {
                        this.form = this.recover(this.form, res.data);
                        this.form.metadataBasicDataAuthorityId = []
                        res.data.metadataBasicDataAuthorityValues.map(item => {
                            this.form.metadataBasicDataAuthorityId.push(item.authorityId)
                        })
                        this.changeEdit(this.form.basicDataAuthority, 1)
                    }
                    this.loading = false
                })
            },
            // 选择人员
            selAuthority(val) {
                this.form.metadataBasicDataAuthorityValues = []
                val.map(item => {
                    this.form.metadataBasicDataAuthorityValues.push(this.userOpt.filter(v=> v.authorityId == item)[0])
                })
            },
            // 选择可修改权限
            changeEdit(val, type) {
                if(type != 1) {
                    this.form.metadataBasicDataAuthorityId = []
                    this.form.metadataBasicDataAuthorityValues = []
                }
                this.permissionName = this.$dictUtils.getDictLabel("basicDataAuthority", val ,'')
                this.dataRule.metadataBasicDataAuthorityId[0].message = this.permissionName + '不能为空'
                if(val == 0) {
                    this.dataRule.metadataBasicDataAuthorityId[0].required = false
                } else {
                    this.dataRule.metadataBasicDataAuthorityId[0].required = true
                    this.$refs['form'].clearValidate(['metadataBasicDataAuthorityId']);
                    this.getUser(val)
                }
            },
            // 查询1部门2人员3角色
            getUser(type) {
                let api = this.api.user.sysuserQueryAllList, p = {
                    current: 1,
                    size: 99999,
                }, method = 'get'
                if(type == 1) {
                    api = this.api.user.getAllDepartment
                    p = {}
                } else if(type == 2) {
                    p.name = ''
                    p.loginName = ''
                } else if(type == 3) {
                    api = this.api.user.sysroleList
                    p.name = ''
                }
                this.userOpt = []
                this.$axios(api, p ,method).then(res => {
                    if (res.status) {
                        if(type == 1) {
                            res.data.map(item => {
                                this.userOpt.push({
                                    authorityId: item.id,
                                    authorityValue: item.departmentName,
                                    disabled: item.enabled == '0' ? false : true
                                })
                            })
                        } else {
                            res.data.records.map(item => {
                                this.userOpt.push({
                                    authorityId: item.id,
                                    authorityValue: item.name,
                                    disabled: item.useable == '0' || item.logicType == '0' ? false : true
                                })
                            })
                        }
                        if (this.method != 'add') {
                            this.form = this.recover(this.form, this.form);
                        }
                        let delOpt = this.form.metadataBasicDataAuthorityId.filter(id => !this.userOpt.some(item => item.authorityId == id))
                        delOpt.map(item => {
                            this.userOpt.push({
                                authorityId: item,
                                authorityValue: '该' + this.permissionName + '已删除',
                                disabled: true
                            })
                        })
                    }
                })
            },
            // 表单提交
            doSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        let api = this.api.metadata.metadatabasicdataSave, type = 'post'
                        if (this.method === 'edit') {  // 新增
                            api = this.api.metadata.metadatabasicdataUpdateById
                            type = 'put'
                        }
                        this.$axios(api, this.form, type).then(data => {
                            if (data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refreshDataList')
                            } else {
                                this.$message.error(data.msg)
                            }
                            this.loading = false
                        })
                    }
                })
            },
        }
    }
</script>
